import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromSite from './site.reducer';

export const selectSiteState = createFeatureSelector<fromSite.SiteState>(fromSite.siteFeatureKey);

export const selectActiveSite = createSelector(selectSiteState, site => site.activeSite);


